var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFarmingAiri = function SvgFarmingAiri(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 19.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M18.002 3.133a17.3 17.3 0 0 0-7.163 2.569l4.283 1.056z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m13.005 9.432 2.117-2.677-4.283-1.044z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M13.006 9.432 10.84 5.711l-.883 4.321zM10.84 5.71a17.3 17.3 0 0 0-5.238 5.187l4.355-.877zM9.352 13.052l.605-3.013-4.355.876zM15.125 6.758l2.88.72V3.133zM3 18.019h4.368l-.714-3.097z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m9.352 13.05-3.75-2.136 1.052 4.25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M5.602 10.914A16.9 16.9 0 0 0 3 18.02l3.654-2.856zM15.126 6.75l-2.118 2.665a12.9 12.9 0 0 1 4.997-1.957zM13.007 9.43l-3.037.6-.617 3.013a13 13 0 0 1 3.654-3.613M9.353 13.047l-2.686 2.1.713 2.858c.29-1.801.98-3.482 1.973-4.958M3 21.992A17 17 0 0 0 5.59 29.1l1.064-4.25z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m9.341 26.945-2.686-2.101-1.065 4.25zM5.602 29.094a17.3 17.3 0 0 0 5.227 5.197l-.884-4.32z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m12.994 30.573-3.037-.612.87 4.333zM6.654 24.85l.714-2.858H3zM18.003 36.873v-4.334l-3.122.696z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m12.994 30.57-2.166 3.722 4.283-1.057zM10.828 34.294a17.3 17.3 0 0 0 7.175 2.581l-2.88-3.625zM6.655 24.85l2.686 2.1a12.66 12.66 0 0 1-1.972-4.958zM9.342 26.953l.605 3.013 3.037.612a13.2 13.2 0 0 1-3.642-3.625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m12.994 30.57 2.117 2.665 2.892-.696a13.2 13.2 0 0 1-5.009-1.969M22.004 36.875a17.3 17.3 0 0 0 7.163-2.569l-4.283-1.056zM27.002 30.57l-2.117 2.665 4.27 1.057zM27.002 30.561l2.153 3.721.883-4.321z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M29.154 34.28a17.3 17.3 0 0 0 5.239-5.186l-4.356.876zM30.654 26.945l-.617 3.013 4.355-.864v-.012zM24.884 33.235l-2.88-.696v4.334zM36.994 21.977h-4.367l.713 3.097z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m30.656 26.949 3.739 2.136-1.053-4.25z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M34.395 29.087a17 17 0 0 0 2.602-7.118l-3.654 2.857zM24.884 33.235l2.117-2.665a12.9 12.9 0 0 1-4.997 1.957zM27.002 30.574l3.036-.6.617-3.013a13.5 13.5 0 0 1-3.654 3.613M30.656 26.95l2.686-2.1-.714-2.858a12.8 12.8 0 0 1-1.972 4.958M37 18.02a17 17 0 0 0-2.59-7.106l-1.065 4.25z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m30.659 13.063 2.686 2.1 1.065-4.249zM30.659 13.06l3.75-2.149-4.367-.864zM34.408 10.909a17.3 17.3 0 0 0-5.227-5.198l.883 4.321zM27.003 9.432l3.037.612-.87-4.333zM33.345 15.164l-.714 2.857H37zM22.007 3.133v4.345l3.121-.708z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m27.004 9.432 2.166-3.721-4.283 1.056z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M29.17 5.714a17.3 17.3 0 0 0-7.174-2.581l2.88 3.625zM33.345 15.163l-2.686-2.1a12.7 12.7 0 0 1 1.972 4.957zM30.66 13.055l-.605-3.013-3.037-.612a13 13 0 0 1 3.642 3.625M27.004 9.438l-2.117-2.665-2.88.709c1.827.3 3.52.984 4.997 1.956M20.002 9.68l-3.049 5.234h6.11zM23.063 14.914l-3.061 5.246H26.1zM26.1 20.164l-3.038 5.246h6.098zM16.953 25.41l3.049-5.246h-6.098z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m23.063 25.41 3.037-5.246h-6.098zM20.002 20.16l3.061-5.246h-6.11zM13.904 20.164l-3.049 5.246h6.098zM20.002 9.68l-3.049 5.234h6.11zM23.063 14.914l-3.061 5.246H26.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m26.1 20.164-3.038 5.246h6.098zM16.953 25.41l3.049-5.246h-6.098z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m23.063 25.41 3.037-5.246h-6.098zM20.002 20.16l3.061-5.246h-6.11zM13.904 20.164l-3.049 5.246h6.098zM9.34 26.953l.617 3.013-4.355-.864z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    stroke: "#F0F2FA",
    rx: 19.5
  })));
};
export default SvgFarmingAiri;